import React, { useEffect } from "react";
import { Alert, IconButton, Snackbar, Slide } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

const NotificationSection = ({ error, success, setError, setSuccess, variant = "dark" }) => {
  const theme = useTheme();
  // 자동 닫기 타이머
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(null);
      }, 5000); // 5초 후 자동 닫기
      return () => clearTimeout(timer);
    }
  }, [success, setSuccess]);

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        setError(null);
      }, 8000); // 에러는 8초 후 자동 닫기
      return () => clearTimeout(timer);
    }
  }, [error, setError]);

  // 테마 기반 스타일 설정
  const getNotificationStyles = (type) => {
    const baseStyles = {
      minWidth: '300px',
      boxShadow: 3,
    };

    if (variant === "dark") {
      return {
        ...baseStyles,
        backgroundColor: theme.palette.secondary.main, // #030405 (검정)
        color: theme.palette.secondary.contrastText,   // #FCFDFE (흰색)
        '& .MuiAlert-icon': {
          color: theme.palette.secondary.contrastText
        }
      };
    }

    // 기본 테마 색상 사용
    return baseStyles;
  };

  return (
    <>
      {/* 성공 알림 - Floating */}
      <Snackbar
        open={!!success}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        TransitionComponent={Slide}
        TransitionProps={{ direction: 'down' }}
        sx={{ top: '80px' }} // 헤더 아래에 표시
      >
        <Alert 
          severity="success"
          variant="filled"
          elevation={6}
          action={
            <IconButton
              size="small"
              onClick={() => setSuccess(null)}
              sx={{ color: "inherit" }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          }
          sx={getNotificationStyles('success')}
        >
          {success}
        </Alert>
      </Snackbar>

      {/* 에러 알림 - Floating */}
      <Snackbar
        open={!!error}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        TransitionComponent={Slide}
        TransitionProps={{ direction: 'down' }}
        sx={{ top: '80px' }} // 헤더 아래에 표시
      >
        <Alert 
          severity="error"
          variant="filled"
          elevation={6}
          action={
            <IconButton
              size="small"
              onClick={() => setError(null)}
              sx={{ color: "inherit" }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          }
          sx={getNotificationStyles('error')}
        >
          {error}
        </Alert>
      </Snackbar>
    </>
  );
};

export default NotificationSection; 